import { canUserCustomAttributeBeEdited } from 'shared-helpers/customAttributes';

import type {
  RequestUser,
  UserCustomAttribute,
  UserCustomAttributes
} from 'shared-types';

interface Params {
  reqUser: RequestUser;
  userCustomAttributes: UserCustomAttribute[];
  userCustomAttributeValues: UserCustomAttributes;
}

const unsetRemovedUserCustomAttributes = ({
  reqUser,
  userCustomAttributes,
  userCustomAttributeValues
}: Params) => {
  // to avoid mutations, work off of a copy of attributes
  const attributesCopy = JSON.parse(JSON.stringify(userCustomAttributeValues));

  const editableAttributeKeys = userCustomAttributes
    .filter((attribute) =>
      canUserCustomAttributeBeEdited({
        user: reqUser,
        userCustomAttribute: attribute
      })
    )
    .map((attribute) => attribute.key);

  const currentAttributeKeys = Object.keys(attributesCopy);
  for (const key of editableAttributeKeys) {
    if (!currentAttributeKeys.includes(key)) attributesCopy[key] = undefined;
  }

  return attributesCopy;
};

export default unsetRemovedUserCustomAttributes;
